module.exports = __webpack_public_path__ + "img/MedFirst.400fef9b.svg";